export const numberCheck=(e)=> {
    const re = /^\d{0,9}(?:\.\d{0,2})?$/;
   
    if (!re.test(e.target.value+e.key)) {
      e.preventDefault();
    }
  }

export const numberCheckNegative = (e) =>{
  const re = /^-?\d{0,9}(?:\.\d{0,2})?$/;
  if (!re.test(e.target.value+e.key)) {
    e.preventDefault();
  }

}